import clsx from 'clsx';
import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { TYPE } from '../../constant';
import { useUserInfo } from '../../hooks';
import { openOcr } from '../../utils/utilityEtc';

function OcrHeader({
  title = "OCR 학습",
  headerStyle,
  headerColorClassName = ""
}) {
  const history = useHistory();
  const { info } = useUserInfo();

  const handleBack = useCallback(() => {
    if (process.env.REACT_APP_ENV === 'local') {
      history.push("/")
    } else {
      const { learnerId } = info;
      openOcr(learnerId);
    }
  }, [history])
  
  return (
    <div
      id="ocrHeader"
      className={
        clsx(
          "header",
          // info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'header_white_font' : '',
          headerColorClassName
        )
      }
      style={headerStyle}
    >
      <div className="inner">
        <div className={clsx(
          "headerBox",
          info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'center' : '',
        )}>
          <div className="headerBox_head">
            <h1 className="tit">
              {title}
            </h1>
            <button
              className="btn-close-wrap"
              onClick={handleBack}
            >닫기</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OcrHeader;